



import Promotion from '../sections/promotion/template_01';






import SECTION_1676449885066 from
'../dynamic_section/dynamic_2/template_01';





import SECTION_PROMOTIONBANNER from
'../dynamic_section/dynamic_2/template_01';





import SECTION_PROMOCONTAINER_1 from
'../dynamic_section/dynamic_1/template_01';





import SECTION_PROMOCONTAINER_2 from
'../dynamic_section/dynamic_1/template_01';



import "./style.css";


const PromotionPage = ()=>{
  
return (
  <div id="promotionPage" class="page ">
  
  

  
  <Promotion desktopTitleToggle={ false }
    mobileTitleToggle={ true } />
  
  
  
  

  
  < SECTION_1676449885066 desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `promo_title` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } numberOfImage={ 1 } titlePosition={ `start` }/>
  
  
  
  

  
  < SECTION_PROMOTIONBANNER desktopToggle={ true }
    mobileToggle={ false } label={ `promotion_banner` } id={ `promotion_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } numberOfImage={ 1 } titlePosition={ `start` }/>
  
  
  
  

  
  < SECTION_PROMOCONTAINER_1 desktopToggle={ true }
    mobileToggle={ false } label={ `PromoContainer` } id={ `Section_promoContainer` }
    imageSize={`1x3`} contentPosition={`right`}
    actionPosition={`bottom`} rowDesktop={ 1 }
    rowMobile={ 1 } numberOfRow={ -1 }
    dataType={`promotion`} noPadding={ false } filter={``}
    titleToggle={ false } titleIconToggle={ true }
    cardPosition={``} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`` } filterTabToggle={ true }
    folderImage={``} noLink={ true }/>
  
  
  
  

  
  < SECTION_PROMOCONTAINER_2 desktopToggle={ false }
    mobileToggle={ true } label={ `PromoContainer` } id={ `Section_promoContainer` }
    imageSize={`1x3`} contentPosition={`bottom`}
    actionPosition={`bottom`} rowDesktop={ 1 }
    rowMobile={ 1 } numberOfRow={ -1 }
    dataType={`promotion`} noPadding={ false } filter={``}
    titleToggle={ false } titleIconToggle={ true }
    cardPosition={``} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`` } filterTabToggle={ true }
    folderImage={``} noLink={ true }/>
  
  
  

  
</div>
)
}

export default PromotionPage;